/** All amounts crossing the Worker interface are integer Hong Kong cents. */
export function money(cents) {
  if (cents === null || cents === undefined) return '—';
  const sign = cents < 0 ? '-' : '';
  const absolute = Math.abs(cents);
  const dollars = Math.floor(absolute / 100).toLocaleString('en-US');
  return `${sign}HK$${dollars}.${String(absolute % 100).padStart(2, '0')}`;
}

export function parseAmountToCents(input) {
  const text = String(input ?? '').trim().replace(/,/g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
  const [dollars, decimals = ''] = text.split('.');
  return Number(dollars) * 100 + Number(decimals.padEnd(2, '0'));
}

export function centsToInput(cents) {
  if (cents === null || cents === undefined) return '';
  return (cents / 100).toFixed(2);
}

export function monthLabel(month) {
  if (!month) return '—';
  return `${month.slice(0, 4)} 年 ${Number(month.slice(5, 7))} 月`;
}

export function dateLabel(date) {
  if (!date) return '—';
  return `${date.slice(0, 4)}/${date.slice(5, 7)}/${date.slice(8, 10)}`;
}

export function timestampLabel(value) {
  if (!value) return '—';
  return `${value.slice(0, 10)} ${value.slice(11, 19)} UTC`;
}

/** Splits a total into equal shares, giving the odd cents to the first member. */
export function splitEvenly(totalCents, count) {
  if (!count) return [];
  const base = Math.floor(totalCents / count);
  const remainder = totalCents - base * count;
  return Array.from({ length: count }, (unused, index) => base + (index < remainder ? 1 : 0));
}

export function nameOf(members, memberId) {
  const member = (members || []).find((candidate) => candidate.id === memberId);
  return member ? member.display_name : '—';
}

export function unitName(units, unitId) {
  const unit = (units || []).find((candidate) => candidate.id === unitId);
  return unit ? unit.name : '—';
}

export function recipientLabel(members, item) {
  if (!item) return '—';
  return item.recipient_kind === 'member' ? nameOf(members, item.recipient_member_id) : item.recipient_name;
}

export const AUDIT_ACTION_LABELS = {
  'item.issued': '發出付款項目',
  'item.issued_by_recurrence': '循環設定產生付款項目',
  'item.corrected': '修改標題／到期日',
  'item.revised': '修改收款人／總額／分攤',
  'item.cancelled': '取消付款項目',
  'submission.created': '提交付款證明',
  'submission.confirmed': '確認付款提交',
  'submission.returned': '退回付款提交',
  'submission.terminated_by_cancellation': '付款提交因取消終止',
  'due.adjusted': '調整應付款',
  'balance.created': '產生結餘',
  'balance.reduced': '結餘因調整減少',
  'balance.returned': '結餘已退回',
  'balance.transferred': '結餘已轉用',
  'historical.recorded': '歷史補錄',
  'historical.corrected': '修正歷史補錄',
  'membership.invited': '邀請成員',
  'membership.invitation_accepted': '成員接受邀請',
  'membership.role_changed': '變更成員角色',
  'recurrence.created': '建立循環設定',
  'recurrence.updated': '修改循環設定',
  'recurrence.disabled': '停用循環設定',
  'equipment.created': '新增設備',
  'proof.uploaded': '上傳圖片',
  'proof.access_granted': '開啟付款證明',
  'ledger.exported': '匯出帳簿',
};

export function auditLabel(action) {
  return AUDIT_ACTION_LABELS[action] || action;
}
